export { MatPaginatorIntlIta } from './MatPaginatorIntlIta';

